import { Random } from "../../alias";
import { Entity, EntityRepository } from "@rauricoste/core";

export type DefInstanceProps<DefName> = {
  id: string;
  defId: string;
  defName: DefName;
};

export class DefInstance<DefName> implements DefInstanceProps<DefName> {
  id: string;
  defId: string;
  defName: DefName;

  constructor(props: DefInstanceProps<DefName>) {
    Object.assign(this, props);
  }
  duplicate(): DefInstance<DefName> {
    return DefInstance.fromDef(this);
  }
  getDef<T extends Entity>(defRepository: EntityRepository<T>): T {
    return defRepository.getById(this.defId);
  }
  static fromDef<DefName>({
    defId,
    defName,
  }: Omit<DefInstanceProps<DefName>, "id">): DefInstance<DefName> {
    return new DefInstance({
      id: Random.nextReadableId(),
      defId,
      defName,
    });
  }
}
